import React, { Component } from 'react';
import { makeObservable, action, observable } from 'mobx';
import { observer } from 'mobx-react';
import MkMessagingStore from 'Stores/mkMessaging/mkMessagingStore';
import MkExistentMessageViewStore from 'Stores/mkMessaging/MkExistentMessageViewStore';
import 'Styles/MkMessaging/messageBodyAndSettingsContainer.scss';
import IconsContainer from "Utils/IconsContainer";
import Popup2 from "Components/Common/Popup2";
import DateTimePicker from 'Components/Common/DateTimePicker';
import HelperDatePickerRange from "Utils/HelperDatePickerRange";
import { ShowModal, GetDateFromString } from "Utils/CommonFunctions";

class MessageBodyAndSettingsContainer extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let messageTitle = this.props.readOnly ? MkExistentMessageViewStore.messageData.title : MkMessagingStore.messageTitle;
        let messageBody = this.props.readOnly ? MkExistentMessageViewStore.messageData.body : MkMessagingStore.messageBody;
        return (
            <div className={`message-title-and-body-container ${this.props.className == null ? '' : this.props.className} `}>
                <div className='message-title-container'>
                    <div className='textbox-title'>Тема {this.props.readOnly ? '' : `(${messageTitle.length} из 200)`}</div>
                    <textarea className='message-textarea message-title-text overflowing-element'
                        placeholder='Тема сообщения'
                        value={messageTitle}
                        onChange={e => MkMessagingStore.HandleTitleInput(e)}
                        readOnly={this.props.readOnly} />
                </div>
                <div className='message-body-container'>
                    <div className='textbox-title'>Текст {this.props.readOnly ? '' : `(${messageBody.length} из 2000)`}</div>
                    <textarea className='message-textarea message-body-text overflowing-element'
                        placeholder='Текст сообщения'
                        value={messageBody}
                        onChange={e => MkMessagingStore.HandleBodyInput(e)}
                        readOnly={this.props.readOnly} />
                </div>
                <div className={`message-expired-date message-setting`}>
                    <div className={this.props.readOnly ? 'setting-title-readOnly' : 'setting-title'}>
                        Срок действия сообщения истекает:
                        {this.props.readOnly ? null : (
                            <Popup2
                                popupText='Сообщение будет действительно вплоть до окончания выбранной даты и времени'
                                moveLeftFromIconPx={130}
                                isTop={true}
                            >
                                {IconsContainer.Get('ci-info')}
                            </Popup2>
                        )}
                    </div>
                    <div className='setting-value-container'>
                        <DateTimePicker
                            getRenderStore={() => MkMessagingStore.newMessageStore.dateTimePickerDropDownState}
                            setRenderStore={action(val => MkMessagingStore.newMessageStore.dateTimePickerDropDownState = val)}
                            getValue={() => this.props.readOnly
                                ? GetDateFromString(MkExistentMessageViewStore.messageData.expiredDate)
                                : MkMessagingStore.messageSettings.messageExpiredDate
                            }
                            setValue={action(val => MkMessagingStore.messageSettings.messageExpiredDate = val)}
                            getMinDate={() => {
                                let dt = new Date(Date.now());
                                dt.setMinutes(dt.getMinutes() + 1);
                                return dt;
                            }}
                            getMaxDate={() => HelperDatePickerRange.GetMaxDateTo()}
                            emptyText="Бессрочное"
                            isTop={true}
                            readOnly={this.props.readOnly}
                            isDefaultTimeEndOfDay={true}
                        />
                    </div>
                </div>

            </div>
        );
    }
}

export default observer(MessageBodyAndSettingsContainer);